var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"rich-button",style:(_vm.getStyle),on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"rich-button__text"},[_vm._v("\n    "+_vm._s(_vm.data)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }